import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-card-dashboard-guest-confirmed',
  templateUrl: './card-dashboard-guest-confirmed.component.html',
  styleUrls: ['./card-dashboard-guest-confirmed.component.scss']
})
export class CardDashboardGuestConfirmedComponent implements OnInit {

  @Input() data: any;

  constructor() { }

  ngOnInit() {}

}
